/* Sends the consented lead-level gallery milestones to the isolated Sheet collector. */
(function () {
  'use strict';
  var endpoint = 'https://script.google.com/macros/s/AKfycbye_lGRMPLUdC5YVj-iccl9_xcmIbcyLpaSuYfNAwEdZEjQ6GlQ38S7MwdlyL3H7noz-w/exec';
  var inquiryId = /^NHL-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var events = { link_click: true, image_view: true, image_like: true, gallery_visit: true, gallery_browse: true, shortlist_open: true, shortlist_start: true, shortlist_submit: true, shortlist_confirmed: true, scroll_25: true, scroll_50: true, scroll_75: true, scroll_100: true };
  var pending = [];
  var seen = {};
  var privacyTimer = null;

  function live() {
    var shop = window.Shopify;
    return shop && shop.theme && shop.theme.role === 'main' && !shop.designMode &&
      !/[?&](preview_theme_id|preview_key|preview_script_id)=/.test(location.search);
  }

  function consent() {
    try {
      var privacy = window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return 'unknown';
      return privacy.analyticsProcessingAllowed() ? 'allowed' : 'denied';
    } catch (_) { return 'unknown'; }
  }

  function flush() {
    var permission = consent();
    if (permission === 'denied') pending = [];
    if (!pending.length && privacyTimer) { clearInterval(privacyTimer); privacyTimer = null; }
    if (permission !== 'allowed' || !live() || !/^https:\/\/script\.google\.com\/macros\/s\/[\w-]+\/exec$/.test(endpoint)) return;
    while (pending.length) {
      var event = pending[0];
      var body = new URLSearchParams({ inquiry_id: event.id, event_name: event.name });
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(endpoint, body)) {
          pending.shift();
          continue;
        }
        // Apps Script redirects its response; no-cors avoids a false CORS failure.
        fetch(endpoint, { method: 'POST', mode: 'no-cors', keepalive: true, body: body }).catch(function () { /* Delivery is unverified; received emails remain authoritative. */ });
        pending.shift();
      } catch (_) { return; }
    }
  }

  window.nhlTrackGalleryLeadEvent = function (name, id) {
    if (!events[name] || !inquiryId.test(id || '') || !live()) return;
    if (consent() === 'denied') return;
    var key = id.toUpperCase() + ':' + name;
    if (seen[key]) return;
    seen[key] = true;
    pending.push({ name: name, id: id });
    flush();
    // Shopify loads its privacy API asynchronously; load/consent events may have
    // already fired. Give queued visits one bounded minute to learn permission.
    if (pending.length && !privacyTimer) {
      var attempts = 0;
      privacyTimer = setInterval(function () {
        flush();
        if (++attempts >= 240 && privacyTimer) { clearInterval(privacyTimer); privacyTimer = null; }
      }, 250);
    }
  };

  document.addEventListener('visitorConsentCollected', function () {
    if (consent() === 'denied') pending = [];
    else flush();
  });
  window.addEventListener('load', flush, { once: true });
})();
